import {
  AssignmentIndOutlined,
  BarChartRounded,
  BusinessRounded,
  CalendarMonthRounded,
  FactCheckOutlined,
  GroupsOutlined,
  HowToRegRounded,
  NotificationsNoneRounded,
  PersonOutlineRounded,
  PostAddRounded,
  PsychologyRounded,
  SearchRounded,
  SendRounded,
  SentimentVerySatisfiedRounded,
  StarRateRounded,
  VerifiedOutlined,
  VideoChatRounded
} from "@mui/icons-material";
import candidateDashboard from "../../../assets/landing/candidate-dashboard-branded.webp";
import heroProfessional1 from "../../../assets/landing/hero-professional-1.jpg";
import heroProfessional2 from "../../../assets/landing/hero-professional-2.jpg";
import heroProfessional3 from "../../../assets/landing/hero-professional-3.jpg";
import jobManagement from "../../../assets/landing/job-management-branded.webp";
import reportsAnalytics from "../../../assets/landing/reports-analytics-branded.webp";
import resumeScreening from "../../../assets/landing/resume-screening-branded.webp";
import testimonialAnkit from "../../../assets/landing/testimonial-ankit.jpg";
import testimonialNeha from "../../../assets/landing/testimonial-neha.jpg";
import testimonialRohit from "../../../assets/landing/testimonial-rohit.jpg";

export const HERO_PROFESSIONALS = [
  { image: heroProfessional1, alt: "NextHire professional" },
  { image: heroProfessional2, alt: "NextHire recruiter" },
  { image: heroProfessional3, alt: "NextHire candidate" }
];

export const PORTALS = [
  {
    id: "employers",
    title: "For Employers",
    subtitle: "Hire smarter with AI",
    description:
      "Post jobs, screen resumes with AI, shortlist the best candidates and streamline your entire hiring process.",
    features: ["AI Resume Screening", "Candidate Ranking", "Analytics & Reports"],
    showcaseFeatures: [
      "AI Resume Screening",
      "Candidate Ranking",
      "Interview Management",
      "Analytics & Reports"
    ],
    icon: BusinessRounded,
    accent: "#451ebb",
    background: "#f6f2fa",
    previewImage: resumeScreening,
    previewAlt: "NextHire AI candidate screening dashboard",
    action: "employer"
  },
  {
    id: "candidates",
    title: "For Candidates",
    subtitle: "Find the right opportunity",
    description:
      "Search jobs, apply quickly, track your applications and take the next step in your career.",
    features: ["Smart Job Search", "Quick Apply", "Application Alerts"],
    showcaseFeatures: [
      "Smart Job Search",
      "One Click Apply",
      "Application Tracking",
      "Job Alerts"
    ],
    icon: PersonOutlineRounded,
    accent: "#006c4b",
    background: "#ecfbf5",
    action: "candidate"
  }
];

export const FEATURES = [
  {
    title: "AI Resume Screening",
    description: "Automatically screen and rank resumes with AI based on job relevance.",
    icon: PsychologyRounded,
    color: "#5d3fd3",
    background: "#eee9ff"
  },
  {
    title: "Candidate Ranking",
    description: "Get best-match candidates instantly with intelligent matching algorithms.",
    icon: StarRateRounded,
    color: "#2563eb",
    background: "#eaf2ff"
  },
  {
    title: "Applicant Tracking",
    description: "Track every candidate at every stage with a visual, intuitive pipeline.",
    icon: AssignmentIndOutlined,
    color: "#d97706",
    background: "#fff6dc"
  },
  {
    title: "Interview Management",
    description: "Schedule interviews and send automated invites and reminders.",
    icon: CalendarMonthRounded,
    color: "#00865e",
    background: "#e1f8ef"
  },
  {
    title: "Offer Management",
    description: "Create, send and track offer letters with digital-signature support.",
    icon: VerifiedOutlined,
    color: "#dc4c64",
    background: "#fff0f2"
  },
  {
    title: "Analytics & Reports",
    description: "Make data-driven hiring decisions with clear recruiting-funnel insights.",
    icon: BarChartRounded,
    color: "#4338ca",
    background: "#eeeeff"
  }
];

export const EMPLOYER_STEPS = [
  { title: "Create Job", description: "Post a job in minutes", icon: PostAddRounded },
  {
    title: "Receive Applications",
    description: "Reach quality candidates",
    icon: GroupsOutlined
  },
  { title: "AI Screening", description: "Rank the best matches", icon: PsychologyRounded },
  { title: "Interview", description: "Schedule interviews", icon: VideoChatRounded },
  { title: "Hire", description: "Select the right candidate", icon: HowToRegRounded }
];

export const CANDIDATE_STEPS = [
  { title: "Search Jobs", description: "Find jobs matching your skills", icon: SearchRounded },
  { title: "Apply", description: "Apply quickly and easily", icon: SendRounded },
  { title: "Track", description: "Follow every application", icon: FactCheckOutlined },
  { title: "Get Notified", description: "Receive status updates", icon: NotificationsNoneRounded },
  {
    title: "Get Hired",
    description: "Start your next journey",
    icon: SentimentVerySatisfiedRounded
  }
];

export const PRODUCTS = [
  {
    title: "AI Resume Screening",
    description: "Automatically rank candidates based on job match",
    image: resumeScreening,
    alt: "NextHire candidate screening dashboard with AI match scores"
  },
  {
    title: "Candidate Dashboard",
    description: "See a complete candidate overview at a glance",
    image: candidateDashboard,
    alt: "NextHire candidate profile and application dashboard"
  },
  {
    title: "Job Management",
    description: "Manage jobs, applications and pipelines in one place",
    image: jobManagement,
    alt: "NextHire visual job and applicant management pipeline"
  },
  {
    title: "Reports & Analytics",
    description: "Use hiring insights to make better decisions",
    image: reportsAnalytics,
    alt: "NextHire recruiting reports and analytics dashboard"
  }
];

export const TESTIMONIALS = [
  {
    quote:
      "NextHire's AI screening saved us hours of manual work. We are able to hire the right talent faster than ever.",
    name: "Ankit Gupta",
    role: "HR Manager, TechCorp",
    image: testimonialAnkit,
    accent: "primary.main"
  },
  {
    quote:
      "The platform is so easy to use. I found my dream job within a week of applying on NextHire.",
    name: "Neha Verma",
    role: "Software Engineer",
    image: testimonialNeha,
    accent: "secondary.main"
  },
  {
    quote:
      "The candidate ranking and analytics help us make better hiring decisions. Highly recommended!",
    name: "Rohit Sharma",
    role: "Talent Lead, InnovateX",
    image: testimonialRohit,
    accent: "primary.main"
  }
];

export const PRICING_AUDIENCES = [
  { id: "candidate", label: "For Job Seekers" },
  { id: "company", label: "For Employers" }
];
